export const IncompleteApplicationItemLayout = {
  component: 'ApplicationListItem',
  props: {
    actionName: 'Continue Application',
    actions: {
      getApplicationItemAdditionalMessageLayout: 'getApplicationItemAdditionalMessageLayout'
    },
    selectors: ['ApplicationInReviewSelector'],
    components: {
      Default: [
        {
          component: 'ApplicationListItemEntry',
          props: {
            selectors: ['ApplicationListItemProductSelector'],
            actions:{
              getTemplate: "getProductTypeTemplate"
            },
            components: {
              Default: {
                component: 'ApplicationListItemID',
                props: {}
              },
              Header:{
                component: "ApplicationListItemEntryHeader",
                props:{
                  selectors: ["ApplicationListItemProductSelector"]
                }
              }
            }
          }
        },
        {
          component: 'ApplicationListItemImageEntry',
          props: {
            selectors: ['ApplicationOwnerSelector'],
            components: {
              Header:{
                component: "ApplicationListItemEntryHeader",
                props:{
                  selectors: ["ApplicationOwnerSelector"]
                }
              }
            }
          }
        },
        {
          component: 'ApplicationListItemEntryAmount',
          props: {
            selectors: ['ApplicationListItemAmountSelector'],
            components:{
              Header:{
                component: "ApplicationListItemEntryHeader",
                props:{
                  selectors: ["ApplicationListItemAmountSelector"]
                }
              }
            }
          }
        },
        {
          component: 'ApplicationListItemEntry',
          props: {
            selectors: ['ApplicationListItemNextStepSelector'],
            components:{
              Header:{
                component: "ApplicationListItemEntryHeader",
                props:{
                  selectors: ["ApplicationListItemNextStepSelector"]
                }
              }
            }
          }
        }
      ],
      Cta:{
        component: "ApplicationListItemContinueCta",
        props: {
          actions:{
            navigateToOpenApplication: 'navigateToOpenApplication'
          }
        }
      },
      Heading:{
        component: 'ApplicationListHeading',
        props:{
          selectors: ['ApplicationInReviewSelector']
        }
      }
    }
  }
}

export const ApplicationItemAdditionalMessageLayout = {
  component: 'ApplicationListItemAdditionalMessage',
  props: {}
}
